import { Md5 } from 'ts-md5';

import { ProfileBody } from '../api/generated/pap';

export const groupByFocusIndustry = (objectArray: ProfileBody[]): Record<string, ProfileBody[]> => {
  return objectArray.reduce(
    (acc, obj) => {
      if (!obj.profileId) {
        throw new Error('profileId is required');
      }
      const key = obj.profileId.split('.').slice(0, 2).join('.');
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    },
    {} as Record<string, ProfileBody[]>
  );
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (!navigator.clipboard) {
      throw new Error('Clipboard API not available');
    }
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Copy failed:', error);
    return false;
  }
};

const TOPCON_CUSTOMER_NUMBER_PATTERN = /:(\d{12}):bp/;
export const extractTopconCustomerNumber = (extId: string): string | undefined => {
  const match = TOPCON_CUSTOMER_NUMBER_PATTERN.exec(extId);
  if (!match) {
    return undefined;
  }

  return match[1];
};

export const getGravatarUrl = async (
  email: string,
  size: number = 80,
  defaultImage: string = 'identicon'
): Promise<string> => {
  const trimmedEmail = email.trim().toLowerCase();
  const hash = Md5.hashStr(trimmedEmail);
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=${defaultImage}`;
};

export const EMAIL_PATTERN =
  '^[a-zA-Z0-9][a-zA-Z0-9_%+-]*(\\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\\.[a-zA-Z]{2,}$';

export const isValidEmail = (email: string) => {
  return email.match(new RegExp(EMAIL_PATTERN));
};
